import { Link } from "react-router-dom";

// One summary, used by both in-app privacy dialogs (Settings and the Help
// menu). They used to carry separate texts that disagreed with each other and
// with the app: different AI provider lists, a claim of "no analytics" while
// session recording was running, and an instruction to email us to delete an
// account when Settings already had a delete button. The public /privacy page
// is the source of truth; this only summarises it.

export default function PrivacySummary({ onNavigate }) {
    return (
        <div className="space-y-3 text-sm leading-relaxed text-muted-foreground" data-testid="privacy-summary">
            <p>We store your account details and the writing you create — novels, chapters, characters, plot notes, versions, and covers.</p>
            <p>When you use an AI feature, the text that request needs is sent to the provider that powers it (Anthropic, OpenAI, or Google) to produce the result. We don't use your writing to train AI models, and we don't sell your data.</p>
            <p>One sign-in cookie. No analytics, advertising trackers, or session recording.</p>
            <p>Beta-reader links are the only way anyone else sees your work, and you can revoke them at any time. You can delete your account from Settings.</p>
            <p>
                <Link to="/privacy" onClick={onNavigate} className="text-primary underline underline-offset-2">
                    Read the full privacy policy
                </Link>
            </p>
        </div>
    );
}
